<template>
  <b-navbar toggleable="lg" type="light" variant="light" fixed="top">
    <b-navbar-brand href="#">
      <img class="logo" src="./../assets/logo.png" width="25" height="25">
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item to="/" :active='$route.name =="main"'>Main</b-nav-item>
        <b-nav-item to="/releasenotes" :active='$route.name =="releasenotes"'>Release Notes</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  name: 'Navigation',
  data() {
    return{
      
    }
  }
}
</script>

<style>
</style>
